import { Post, IBlock } from "@pulsex/types";
import widgetStylesRegistry from "./widgetsStylesRegistry";
import groupIdRegistry from "./groupIdRegistry";

export function transformCode(code: string) {
    return code?.toLowerCase()?.replaceAll(" ", "_");
}

export function getWidgetByStyle(style: string) {
    return widgetStylesRegistry[style];
}

export function getComponentByGroup(groupId: string) {
    return groupIdRegistry[groupId];
}

export function getComponentByBlock(block: IBlock) {
    if (block.widgets?.length > 1) return getComponentByGroup(block.id);
    else return getWidgetByStyle(block.id);
}

export function slicePosts(
    posts: Post[],
    sliceSizes: number[]
): Array<Post & Array<Post>> {
    if (
        sliceSizes.reduce((acc, item) => (acc = acc + item), 0) > posts.length
    ) {
        console.error(
            "Slicing not possible due to insufficient length of array"
        );

        return [];
    }

    const result: any[] = [];
    let index = 0;

    for (let size of sliceSizes) {
        let slicedPart: any = posts.slice(index, index + size);
        if (slicedPart.length === 1) slicedPart = slicedPart[0];
        result.push(slicedPart);
        index += size;
    }

    return result;
}
